// extracted by mini-css-extract-plugin
export var sponsorsContainer = "styles-module--sponsorsContainer--16jFe";
export var logoLink = "styles-module--logoLink--3P4lj";
export var logo = "styles-module--logo--2crh_";
export var sponsorsSection = "styles-module--sponsorsSection--1rLAR";